/* IMPORT */
import Root from '../objects/root.js';
import { callStack } from './debugger.js';
/* MAIN */
const root = (fn) => {
    const stack = callStack();
    return new Root(true).wrap(fn, undefined, undefined, stack);
};
/* EXPORT */
export default root;
